import { useQuery, gql } from "@apollo/client";
import { Server } from "../../apollo/types";
import { useGetAuthedAtTimestamp } from "../auth/useGetAuthedAtTimestamp";

export const GET_PATIENT_REFLECTION_TOPICS_COUNT_QUERY = gql`
  query GetPatientReflectionTopicsCount($patientShortId: ID!) {
    patient(patientShortId: $patientShortId) {
      shortId
      reflectionTopics {
        totalCount
      }
    }
  }
`;

export const useGetReflectionTopicCountQuery = (patientShortId: string) => {
  const [authedAtTimestamp] = useGetAuthedAtTimestamp();
  const { data, loading, error } = useQuery(
    GET_PATIENT_REFLECTION_TOPICS_COUNT_QUERY,
    {
      variables: {
        patientShortId: patientShortId,
      },
      context: {
        server: Server.MONOLITH,
      },
      skip: !authedAtTimestamp,
    },
  );
  return { data, loading, error };
};
